export default "__VITE_ASSET__DyracZ99__"